<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="use-supplies-list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="[]"
            dialogWidth="65%"
            class="form-table-h360"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @LoadingbatchPickingView="LoadingbatchPickingView"
            @LoadingbatchReturnView="LoadingbatchReturnView"
        >
            <slot slot="filter">
                <el-col :span="2">
                    <item-input type="select" v-model="timeType" :options="timeTypes" placeholder="时间类型"></item-input>
                </el-col>
                <el-col :span="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="select" v-model="dic_section_id" :options="section_auth" :clearable="true" placeholder="请选择科室"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="multiselect" v-model="suppliesStatus" :options="enum_suppliesStatus" :clearable="true" placeholder="状态"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="LoadingbatchPickingView">扫码领用</el-button>
                <el-button type="primary" size="mini" @click="LoadingbatchReturnView">扫码归还</el-button>
            </slot>
        </crud-facecade>
        <cus-dialog class="form-table-h380" title="批量领用" :visible.sync="batchPickingView.dialogFormVisible" :close-on-click-modal="false" @confirm="formbatchPicking" width="40%">
            <cus-form ref="form-batchPicking" :data="batchPickingViewData" :columns="batchPickingColumns" @extrabutton-click="ExtraButtonClick" @confirm="batchPicking"></cus-form>
        </cus-dialog>
        <cus-dialog class="form-table-h380" title="批量归还" :visible.sync="batchReturnView.dialogFormVisible" :close-on-click-modal="false" @confirm="formbatchReturn" width="40%">
            <cus-form ref="form-batchReturn" :data="batchReturnViewData" :columns="batchReturnColumns" @extrabutton-click="ExtraButtonClick" @confirm="batchReturn"></cus-form>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `SuppliesUsed`,
    data() {
        return {
            title: `耗材领用归还`,
            o_dic_operating_ward_id: undefined,
            dic_section_id: undefined,
            barcode: undefined,
            workerList: [],
            surgeryList: [],
            suppliesStatus: [1],
            timeType: `领用时间`,
            timeTypes: [
                { value: `领用时间`, label: `领用时间` },
                { value: `归还时间`, label: `归还时间` }
            ],
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            issetoperatingward: false,
            enum_supplies: [],
            allSupplies: [],
            receivers: [],
            suppliesBatchScan: 0,
            rdate: [
                this.$moment().format(`YYYY/MM/DD`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`)
            ],
            enum_suppliesStatus: [
                { value: 1, label: `已领用` },
                { value: 2, label: `已使用` },
                { value: 3, label: `已归还` }
            ],
            receive: {
                dialogFormVisible: false,
                data: {},
                suppliesId: 0
            },
            returnInfo: {
                dialogFormVisible: false,
                data: {},
                suppliesId: 0
            },
            batchPickingView: {
                dialogFormVisible: false
            },
            batchPickingViewData: {},
            batchReturnView: {
                dialogFormVisible: false
            },
            batchReturnViewData: {},
            url: {
                baseURL: `/api/Nursing/UseSupplies`,
                get: () => {
                    return this.loadUseSupplies()
                }
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.loadSupplies()
        this.dic_section_id = this.currentUser && this.currentUser.dic_worker_section_id
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `ward_auth`, `currentUser`, `sys_enums`, `section_auth`, `operation_ward_auth`, `recovery_ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        workers() {
            return this[`sysuser/workers`]
        },
        // eslint-disable-next-line vue/no-dupe-keys
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        operationRoom() {
            let that = this
            let rooms = []
            if (this.operation_ward_auth) {
                let ward = _.filter(this.operation_ward_auth, { value: that.dic_operating_ward_id })
                if (ward && ward[0] && ward[0].operation_room) {
                    rooms =
                        ward[0].operation_room.map(d => {
                            d.code = ``
                            return d
                        }) || []
                }
            }
            return rooms
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    width: `150`,
                    options: this.section_auth,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: `住院号`,
                    width: `100`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `dic_supplies_id`,
                    label: `耗材`,
                    width: `200`,
                    isListable: true,
                    options: this.enum_supplies,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `barcode`,
                    label: `条码号`,
                    width: `150`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `status`,
                    label: `状态`,
                    width: `100`,
                    options: this.enum_suppliesStatus,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    width: `100`,
                    isListable: true,
                    searchable: true,
                    options: this.operationRoom
                },
                {
                    type: `select`,
                    prop: `receiver_id`,
                    label: `领用人`,
                    width: `100`,
                    isListable: false,
                    searchable: true,
                    options: this.receivers
                },
                {
                    type: `string`,
                    prop: `receiver`,
                    label: `领用人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `receive_date`,
                    label: `领用时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `quantity`,
                    label: `领用数量`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `returnee`,
                    label: `归还人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `back_quantity`,
                    label: `归还数量`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `return_date`,
                    label: `归还时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `use_quantity`,
                    label: `使用数量`,
                    width: `140`,
                    isListable: true
                }
            ]
        },
        batchPickingColumns() {
            let me = this
            return [
                {
                    type: `scan`,
                    prop: `barcode`,
                    label: `条码号`,
                    colspan: 20,
                    placeholder: `请扫码或者手动输入条码号`,
                    autofocus: true,
                    change: function($that, { row }) {
                        me.batchPickingScan(row)
                    },
                    config: {
                        autofocus: true
                    }
                },
                {
                    type: `table2`,
                    prop: `items`,
                    label: `清单`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            prop: `barcode`,
                            label: `耗材编码`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `dic_supplies_id`,
                            label: `名称`,
                            width: `150`,
                            options: me.enum_supplies,
                            isListable: true
                        },
                        {
                            type: `number`,
                            prop: `quantity`,
                            label: `数量`,
                            width: `150`,
                            isListable: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `150`,
                            isListable: true,
                            readonly: false,
                            options: function(that, { row }) {
                                return [
                                    {
                                        class: `is-plain`,
                                        label: `移除`,
                                        icon: ``,
                                        type: `danger`,
                                        emit: `removerow1`,
                                        permission: `default`
                                    }
                                ]
                            },
                            fixed: `right`
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 400
                    }
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    readonly: false,
                    colspan: 12,
                    options: this.operationRoom
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    readonly: false,
                    colspan: 12,
                    default: this.currentUser && this.currentUser.dic_worker_section_id,
                    options: this.section_auth,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `receiver_id`,
                    label: `领用人`,
                    readonly: false,
                    colspan: 12,
                    default: this.currentUser && this.currentUser.dic_worker_id,
                    options: this.workerList,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: function($that, { row }) {
                        if (row.receiver_id) {
                            var receiverInfo = _.filter(me.workerList, { value: row.receiver_id })[0]
                            row.dic_section_id = receiverInfo && receiverInfo.remark
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `biz_surgery_info_id`,
                    label: `住院患者`,
                    readonly: false,
                    options: this.surgeryList,
                    colspan: 12,
                    change: function($that, { row }) {
                        if (row.biz_surgery_info_id) {
                            var surgeryInfo = _.filter(me.surgeryList, { value: row.biz_surgery_info_id })[0]
                            row.visit_no = surgeryInfo && surgeryInfo.jianpin
                            if (surgeryInfo && surgeryInfo.remark) {
                                row.dic_operating_room_id = surgeryInfo && surgeryInfo.remark
                            }
                        }
                    }
                }
            ]
        },
        batchReturnColumns() {
            let me = this
            return [
                {
                    type: `scan`,
                    prop: `barcode`,
                    label: `条码号`,
                    colspan: 20,
                    placeholder: `请扫码或者手动输入条码号`,
                    autofocus: true,
                    change: function($that, { row }) {
                        if (!$that.emitNewScan) {
                            $that.emitNewScan = _.debounce(function() {
                                $that.$emit(`new-scan`, row)
                            }, 1000)
                        }
                        $that.emitNewScan()
                        me.batchReturnScan(row)
                    },
                    config: {
                        autofocus: true
                    }
                },
                {
                    type: `table2`,
                    prop: `items`,
                    label: `清单`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            prop: `barcode`,
                            label: `耗材编码`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `dic_supplies_id`,
                            label: `名称`,
                            width: `150`,
                            options: me.enum_supplies,
                            isListable: true
                        },
                        {
                            type: `number`,
                            prop: `back_quantity`,
                            label: `数量`,
                            width: `150`,
                            isListable: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `150`,
                            isListable: true,
                            readonly: false,
                            options: function(that, { row }) {
                                return [
                                    {
                                        class: `is-plain`,
                                        label: `移除`,
                                        icon: ``,
                                        type: `danger`,
                                        emit: `removerow2`,
                                        permission: `default`
                                    }
                                ]
                            },
                            fixed: `right`
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 400
                    }
                },
                {
                    type: `select`,
                    prop: `returnee_id`,
                    label: `归还人`,
                    readonly: false,
                    colspan: 12,
                    options: this.workerList,
                    default: this.currentUser && this.currentUser.dic_worker_id,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `return_date`,
                    label: `归还时间`,
                    readonly: false,
                    colspan: 12,
                    default: _.now(),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        }
    },
    methods: {
        loadWorkerList() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForOperatingWard?operatingWardId=${this.dic_operating_ward_id || -1}`)
                req.then(data => {
                    this.workerList = data
                    resolve(data)
                })
            })
        },
        loadSurgeryList() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Nursing/UseSupplies/loadSurgeryList?operatingWardId=${this.dic_operating_ward_id || -1}`)
                req.then(data => {
                    this.surgeryList = data
                    console.log(`this.surgeryList`)
                    console.log(this.surgeryList)
                    resolve(data)
                })
            })
        },
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        isHavePermissions(permiskey) {
            return true // this.permissions && this.permissions.findIndex(item => item.permission === `package:${permiskey}`) != -1
        },
        loadSupplies() {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Supplies/Get`)
            req.then(data => {
                that.enum_supplies = _.filter(data, { is_deleted: false }).map(d => {
                    return {
                        value: d.id,
                        label: d.name,
                        jianpin: d.abbr,
                        code: d.code
                    }
                })
            }).catch(e => {
                that.enum_supplies = []
            })
        },
        loadUseSupplies() {
            return new Promise((resolve, reject) => {
                let that = this
                let status = ``
                if (that.suppliesStatus && that.suppliesStatus.length > 0) {
                    status = this.suppliesStatus.join(`,`)
                }
                let req = this.myaxios.get(
                    `/api/Nursing/UseSupplies/GetUseSupplies?wardid=${that.dic_operating_ward_id}&status=${status}&timeType=${that.timeType}&from=${that.rdate[0]}&to=${that.rdate[1]}`
                )
                req.then(data => {
                    if (that.dic_section_id && that.dic_section_id > 0) {
                        data = _.filter(data, function(i) {
                            return i.dic_section_id == that.dic_section_id
                        })
                    }
                    if (that.barcode && that.barcode.trim() != ``) {
                        data = _.filter(data, function(i) {
                            return i.barcode.toUpperCase() == that.barcode.trim().toUpperCase()
                        })
                    }
                    that.allSupplies = data

                    var sectionList = _.filter(data, function(i) {
                        return i.receiver_id > 0
                    })
                    let worker = _.cloneDeep(that.workers)
                    that.receivers = _.reduce(
                        _.groupBy(sectionList,
                            `receiver_id`
                        ),
                        function(result, value, key) {
                            let sOne = _.find(worker, d => {
                                return d.id == key
                            })
                            if (sOne) {
                                result.push({
                                    value: sOne.id,
                                    label: sOne.name,
                                    jianpin: sOne.abbr
                                })
                            }
                            return result
                        },
                        []
                    )
                    that.loadWorkerList()
                    that.loadSurgeryList()
                    resolve(data)
                })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        LoadingbatchPickingView() {
            this.batchPickingView.dialogFormVisible = true
            this.batchPickingViewData = {}
            this.batchPickingViewData.items = []
        },
        formbatchPicking() {
            this.$refs[`form-batchPicking`].confirm()
        },
        formbatchReturn() {
            this.$refs[`form-batchReturn`].confirm()
        },
        batchPicking(row) {
            let that = this
            if (!row.items || row.items.length == 0) {
                that.$message.warning(`请录入待领用耗材！`)
                return
            }
            return new Promise((resolve, reject) => {
                let requestData =
                    row.items &&
                    row.items.map(d => {
                        d.status = 1 // 领用
                        d.receiver_id = row.receiver_id
                        d.dic_operating_ward_id = that.dic_operating_ward_id
                        d.dic_operating_room_id = row.dic_operating_room_id
                        d.dic_section_id = row.dic_section_id
                        d.biz_surgery_info_id = row.biz_surgery_info_id || 0
                        d.visit_no = row.visit_no
                        return d
                    })
                let req = that.myaxios.put(`/api/Nursing/UseSupplies/UseSuppliesPutMany?type=1`, requestData)
                req.then(data => {
                    that.batchPickingViewData = {}
                    that.batchPickingView.dialogFormVisible = false
                    that.$refs[`use-supplies-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        LoadingbatchReturnView() {
            this.batchReturnView.dialogFormVisible = true
            this.batchReturnViewData = {}
            this.batchReturnViewData.items = []
        },
        batchReturn(row) {
            let that = this
            if (!row.items || row.items.length == 0) {
                that.$message.warning(`请录入待归还耗材！`)
                return
            }
            return new Promise((resolve, reject) => {
                let requestData =
                    row.items &&
                    row.items.map(d => {
                        d.status = 3 // 归还
                        d.returnee_id = row.returnee_id
                        d.return_date = row.return_date
                        return d
                    })
                let req = that.myaxios.put(`/api/Nursing/UseSupplies/UseSuppliesPutMany?type=3`, requestData)
                req.then(data => {
                    row = {}
                    that.batchReturnViewData = {}
                    that.batchReturnView.dialogFormVisible = false
                    that.$refs[`use-supplies-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        removerow1({ index, row }) {
            // 移除一行
            this.batchPickingViewData.items.splice(index, 1)
        },
        removerow2({ index, row }) {
            // 移除一行
            this.batchReturnViewData.items.splice(index, 1)
        },
        batchPickingScan(row) {
            let that = this
            console.log(row)
            var data = {
                barcode: row.barcode.trim(),
                useType: 1 // 领用
            }
            let req = this.myaxios.post(`/api/Nursing/UseSupplies/UseSuppliesBatchScan`, data)
            req.then(data => {
                var info = {
                    barcode: data.barcode,
                    dic_supplies_id: data.dic_supplies_id,
                    quantity: data.quantity
                }
                var iteminfo = that.batchPickingViewData && that.batchPickingViewData.items && _.filter(that.batchPickingViewData.items, { barcode: data.barcode })
                if (!iteminfo || iteminfo.length == 0) {
                    that.batchPickingViewData.items.push(info)
                } else {
                    that.$message.warning(`已录入`)
                }
            }).catch(e => {
                console.log(e)
            })
            that.$refs[`form-batchPicking`].$refs.ItemInput[0].scan_val = ``
        },
        batchReturnScan(row) {
            console.log(row)
            let that = this
            var data = {
                barcode: row.barcode.trim(),
                useType: 3 // 领用
            }
            let req = this.myaxios.post(`/api/Nursing/UseSupplies/UseSuppliesBatchScan`, data)
            req.then(data => {
                var info = {
                    id: data.id,
                    biz_surgery_info_id: data.biz_surgery_info_id,
                    barcode: data.barcode,
                    dic_supplies_id: data.dic_supplies_id,
                    back_quantity: data.back_quantity
                }
                var iteminfo = that.batchReturnViewData && that.batchReturnViewData.items && _.filter(that.batchReturnViewData.items, { barcode: data.barcode })
                if (!iteminfo || iteminfo.length == 0) {
                    that.batchReturnViewData.items.push(info)
                } else {
                    that.$message.warning(`已录入`)
                }
            }).catch(e => {
                console.log(e)
            })
            that.$refs[`form-batchReturn`].$refs.ItemInput[0].scan_val = ``
        }
    },
    watch: {
        dic_operating_ward_id: function() {
            this.$refs[`use-supplies-list`].ReloadListData()
        },
        dic_section_id: function() {
            this.$refs[`use-supplies-list`].ReloadListData()
        },
        suppliesStatus: function() {
            this.$refs[`use-supplies-list`].ReloadListData()
        },
        barcode: function() {
            this.$refs[`use-supplies-list`].ReloadListData()
        },
        rdate: function() {
            this.$refs[`use-supplies-list`].ReloadListData()
        },
        timeType: function() {
            this.$refs[`use-supplies-list`].ReloadListData()
        }
    }
}
</script>
<style>
.el-form-item.item.name p {
    font-weight: bold;
    color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Counting/UseSupplies.vue